import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';
import pxToRem from 'styles/pxToRem';

import { accountSignUpSendCode } from 'redux/modules/account';

import SignUpPhoneChangeForm from './SignUpPhoneChangeForm';
import SignUpPhoneConfirmForm from './SignUpPhoneConfirmForm';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: 376,
    paddingBottom: 58,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: 556,
    },
  },
  form: {
    padding: '0 16px 16px',
    [theme.breakpoints.up('sm')]: {
      padding: '25px 113px 0',
    },
  },
  grid: {
    display: 'flex',
  },
  footer: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    padding: '8px 16px',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    [theme.breakpoints.up('sm')]: {
      padding: '8px 63px',
    },
    '& $grid': {
      justifyContent: 'space-between',
    },
  },
  typography: {
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: 14,
    margin: `${pxToRem(24)} ${pxToRem(113)}`,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  typographyText: {
    fontSize: pxToRem(13),
    margin: `0 ${pxToRem(113)} ${pxToRem(16)}`,
  },
});

class SignUpPhoneConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneConfirmed: false,
    };

    this.onCodeSend = this.onCodeSend.bind(this);
  }

  onCodeSend(values) {
    const { actions, initialValues } = this.props;
    actions.accountSignUpSendCode({
      values,
    });
  }

  render() {
    const { form, submitting, onSubmitSuccess, actions, initialValues, onPhoneChange, classes } = this.props;
    const { phoneConfirmed } = this.state;

    return (
      <Paper
        className={classes.root}
        square
        elevation={5}
      >
        <Typography
            className={classes.typography}
            color="secondary"
          >
            {phoneConfirmed
              ? <Fragment>Let's Confirm your mobile number</Fragment>
            : <Fragment>We really value security, <br /> all your data is HIPAA protected</Fragment>}
        </Typography>
        <Typography
          className={classes.typographyText}
          align="center"
        >
          {phoneConfirmed
            ? (<Fragment>
              Enter the Six Digit Code that was sent to <br />
              {initialValues['Phone Number']}. <br />
              This code expires in 30 Minutes.
            </Fragment>
            ) : 'Check to make sure your Mobile number is entered properly. We will send you a Code for Verification.'}
        </Typography>
        {phoneConfirmed ? (
          <SignUpPhoneConfirmForm
            className={classes.form}
            form={form}
            onSubmitSuccess={onSubmitSuccess}
            initialValues={initialValues}
            onCodeSend={() => {
              this.onCodeSend(initialValues);
            }}
          />
        ) : (
          <SignUpPhoneChangeForm
            className={classes.form}
            form={`${form}-change`}
            onSubmit={(values) => {
              this.onCodeSend(values);
              onPhoneChange(values);
              this.setState({ phoneConfirmed: true });
            }}
            initialValues={initialValues}
          />
        )} 
        <div className={classes.footer}>
          <Grid
            className={classes.grid}
            container
            justify="space-between"
            alignItems="center"
            spacing={16}
          >
            <Grid item>
              <Typography variant="caption">
                STEP 3/4
              </Typography>
            </Grid>
            <Grid item>
              <Grid
                container
                justify="space-between"
                alignItems="center"
                spacing={16}
              >
                <Grid item>
                  <Button
                    onClick={() => actions.submit(phoneConfirmed ? form : `${form}-change`)}
                    variant="raised"
                    color="primary"
                    size="lg"
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
};

SignUpPhoneConfirm.propTypes = {
  form: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  onSubmitSuccess: PropTypes.func,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
    accountSignUpSendCode: PropTypes.func.isRequired,
  }).isRequired,
  onPhoneChange: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
  }).isRequired,
};

SignUpPhoneConfirm.defaultProps = {
  form: 'sign-up-phone-confirm',
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, accountSignUpSendCode }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SignUpPhoneConfirm),
);



// WEBPACK FOOTER //
// ./src/components/account/SignUpPhoneConfirm/SignUpPhoneConfirm.js